import React, { useState } from 'react';
import PopupBtmNotInputCarInfo from "./PopupBtmNotInputCarInfo";

function PopupBtmNotCallNumber({carNumber, resetCarNumber}) {
    const [isInput, setisInput] = useState(false);


    return (
        <>
        {
          isInput ? (
            <PopupBtmNotInputCarInfo carNumber={carNumber} />
          ) : (
            <div className="fixed bg-[rgba(0,0,0,0.7)] top-0 left-0 w-full h-full flex items-end justify-center z-10 ">
              <div className="bg-[#fff] w-full p-5 pt-10 min-h-64 rounded-t-2xl max-w-screen-md relative">
                  <button className="absolute top-0 left-0 flex justify-center w-full h-10 pt-4 m-auto rounded-xl">
                      <span className="w-10 h-1 bg-[#E1E2E4] rounded-xl"></span>
                  </button>
                  <h3 className="text-[#1B1C1E] text-left font-semibold text-[22px] mb-4">
                    사고 차량 {carNumber} 정보를<br />
                    불러오지 못했어요.
                  </h3>
                  <p className="text-[#878A92] text-left text-[16px]">
                    입력하신 사고 차량 번호가 맞다면<br />
                    사고 차량 정보를 직접 입력해주세요.
                  </p>
                  <div className="flex justify-between mt-8 gap-[10px]">
                    <button className="flex items-center justify-center w-full h-[52px] bg-[#F4F4F5] rounded-lg" onClick={() => resetCarNumber()}>취소</button>
                    <button className="flex items-center justify-center w-full h-[52px] bg-[#313A4C] rounded-lg text-white" onClick={() => setisInput(true)}>차량번호 직접 입력</button>
                  </div>
              </div>
          </div>
          )
        }
        </>

    );
}

export default PopupBtmNotCallNumber;
